import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function

// Function to delete a photo from a document
const deletePhoto = async (docid, photoid, token, folderid, prefix) => {
  // Define the endpoint URL
  const url =
    prefix + `folders/${folderid}/documents/${docid}/photo/${photoid}`;

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the DELETE request
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      return "User document not found";
    }

    const org_id = userSnapshot.get("org_id");

    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "", // Optional additional fields
      "",
      JSON.stringify({}), // Request body as string (empty in this case)
      await response.text() // Response body as text
    );

    // Check if the request was successful
    if (response.ok) {
      return "Photo deleted successfully"; // Success message
    } else {
      // Handle error response
      console.error(`Failed to delete photo: ${response.status}`);
      return `Failed to delete photo: ${response.status}`;
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return `Exception occurred: ${error.message}`;
  }
};

export default deletePhoto;
